<template>
  <div class="lc-editor-contract">
    <divider orientation="left">Сведения о проекте</divider>
    <div class="lc-editor-contract__name ms-small-head">
      {{ contract.code }}. {{ contract.name }}
    </div>
    <div class="lc-editor-contract__customer ms-help">
      Заказчик: <b>{{ contract.customer }}</b>
    </div>
    <div class="lc-editor-contract__customer ms-help">
      Исполнитель: <b>{{ contract.performer }}</b>
    </div>
  </div>
</template>

<script>
export default {
  props: ['contract']
}
</script>

<style lang="less">
.lc-editor-contract {
  &__name {
    margin-bottom: 4px;
    word-break: break-all;
  }
}
</style>
